<template>
  <div class="rules-wrapper">
    <div class="rules section-enter-animation-mobile">
      <img src="/images/keys.svg" alt="" class="img img--keys" />

      <span class="content">
        Jeżeli uważasz, że reklama naszego produktu narusza zasady Kodeksu Etyki
        Reklamy,
        <a
          href="https://radareklamy.pl/kodeks-etyki/"
          class="link link--advert"
          target="_blank"
          rel="noopener noreferrer"
          v-text="'kliknij.'"
        />

        Możesz też zapoznać się z naszą

        <a
          href="https://grupazywiec.pl/polityka-cookies/"
          class="link link--advert"
          target="_blank"
          rel="noopener noreferrer"
          v-text="'Polityką plików cookies.'"
        />

        <br />

        <a
          href="/regulamin.pdf"
          class="link link--big"
          target="_blank"
          rel="noopener noreferrer"
          v-text="'Regulamin serwisu'"
        />

        <div
          role="button"
          class="link link--big"
          @click="showCookieSettings"
          v-text="'Ustawienia cookies'"
        />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showCookieSettings() {
      window.OneTrust?.ToggleInfoDisplay()
    }
  }
}
</script>

<style lang="scss" scoped>
.rules {
  font-size: 12px;
  line-height: 1.1em;

  @include center-content(vertically);

  @include media-down(xl) {
    font-size: 10px;
  }

  @include media-down(lg) {
    @include center-content;
    flex-direction: column;

    height: $vh;

    background-color: $background-color;
    padding: 0 120px;

    text-align: center;
    font-size: 26px;
  }

  @include media-down(md) {
    font-size: 12px;
    padding: 0 40px;
  }
}

.img {
  width: 36px;
  min-width: 36px;
  margin-right: 17px;

  @include media-down(lg) {
    margin-right: 0;
    margin-bottom: 43px;
    width: 67px;
  }

  @include media-down(md) {
    width: 30px;
    margin-bottom: 20px;
  }

  &--keys {
    @include media-down(md) {
      backface-visibility: hidden;
    }
  }
}

.content {
  max-width: 600px;

  @include media-down(md) {
    backface-visibility: hidden;
  }
}

.link {
  color: $text-color;
  margin-left: 4px;
  text-decoration: underline;
  cursor: pointer;

  &--no-margin {
    margin-left: 0;
  }

  &--big {
    text-transform: uppercase;

    @include media-down(lg) {
      display: block;
      margin-top: 30px;
    }

    @include media-down(md) {
      margin-top: 15px;
    }
  }
}

.md-up {
  @include hide-down(lg);
}
</style>
